export default __webpack_public_path__ + "static/media/django.db7b5655.svg";